import { EPendencyRateCode } from "@payfac/types";

export const PENDENCY_CODE_PILL_STATE = {
  [EPendencyRateCode.NEGATIVE_RATE]: "error",
  [EPendencyRateCode.DEFAULT_RATE]: "warning",
} as const;

export const PENDENCY_CODE_VALUE_SUB_KEY = {
  [EPendencyRateCode.NEGATIVE_RATE]: "payfac.pagePendenciesCarouselValueSubNegative",
  [EPendencyRateCode.DEFAULT_RATE]: "payfac.pagePendenciesCarouselValueSubDefault",
} as const;
